import { createDynamicThunk } from ".";

export const getSettingListThunk = createDynamicThunk({
  typePrefix: "settings/getSettingListThunk",
  useHandleSearch: true,
});

export const addSettingThunk = createDynamicThunk({
  typePrefix: "settings/addSettingThunk",
  endpoint: "/settings",
  method: "POST",
  refreshList: true,
  listThunk: getSettingListThunk,
});

export const deleteSettingThunk = createDynamicThunk({
  typePrefix: "/deleteSettingThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getSettingListThunk,
});
